export const getters = {
  systemTrucks: state => state.trucks,
  Truck: state => state.systemTruck
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucks/getters.js